import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { LoadingState, StateMessage } from '@/components/StateMessage/StateMessage';
import { useFeatureFlags } from '@/features/platform/useFeatureFlags';
import styles from '@/features/projects/ProjectGate.module.css';

export function CopilotFlagGate({ children }: { children: ReactNode }) {
  const { isEnabled, isLoading } = useFeatureFlags();

  if (isLoading) return <LoadingState />;
  if (!isEnabled('copilot_v1')) {
    return (
      <StateMessage title="Copilot staat uit">
        Schakel <code>copilot_v1</code> in via Instellingen → Platform (org owner).
        <div className={styles.actions}>
          <Link to="/app/instellingen/platform" className={styles.link}>
            Naar platforminstellingen
          </Link>
        </div>
      </StateMessage>
    );
  }
  return <>{children}</>;
}
